<template>
  <v-container fluid>
    <alert-unsaved-changes v-if="unsavedChanges"></alert-unsaved-changes>
    <v-form
      v-show="!loading && !resourceLoading"
      ref="form"
      v-model="valid"
      :lazy-validation="false"
    >
      <v-row>
        <v-col v-if="!next" cols="12">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t('optional-info') }}
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pt-10">
                <v-row>
                  <v-col v-if="!next" cols="12">
                    <label>{{ $t('payment-model') }}</label>
                    <p class="label-info">
                      {{ $t('payment-model-message') }}
                    </p>
                    <tiptap-vuetify
                      v-model="resource.paymentModel"
                      :placeholder="'Max length is 500 characters'"
                      :extensions="extensions"
                      :disabled="!edit"
                      class="required"
                      :rules="requiredRule()"
                    ></tiptap-vuetify>
                    <div :class="charCount > maxChars ? 'red--text' : 'black--text'">
                      {{ charCount }} / {{ maxChars }} characters
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <label>{{ $t('pricing') }}</label>
                    <p class="label-info">
                      {{ $t('pricing-message') }}
                    </p>
                    <tiptap-vuetify
                      v-model="resource.pricing"
                      :placeholder="'Max length is 500 characters'"
                      :extensions="extensions"
                      :disabled="!edit"
                      class="required"
                      :rules="requiredRule()"
                    ></tiptap-vuetify>
                    <div :class="pricingCharCount > maxChars ? 'red--text' : 'black--text'">
                      {{ pricingCharCount }} / {{ maxChars }} characters
                    </div>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <!--BUTTONS-->
      <v-row class="my-5" v-if="!next && edit" justify="end">
        <v-btn outlined class="black--text font-weight-bold mx-2" rounded x-large @click="cancel()">
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          depressed
          rounded
          x-large
          color="primary200"
          class="white--text font-weight-bold"
          @click="add()"
          :disabled="!valid || charCount > maxChars || pricingCharCount > maxChars"
          >{{ $t('update') }}
        </v-btn>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import util from '@/mixins/util.js';
import AlertUnsavedChanges from '@/components/shared/helpers/AlertUnsavedChanges';
import EventBus from '@/helpers/event-bus.js';
import {
  TiptapVuetify,
  Bold,
  Italic,
  Underline,
  Strike,
  ListItem,
  BulletList,
  OrderedList,
} from 'tiptap-vuetify';

export default {
  name: 'ResourcePricingInfo',
  mixins: [util],
  components: {
    AlertUnsavedChanges,
    TiptapVuetify,
  },
  props: {
    admin: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [Number, String],
      default: null,
    },
    edit: {
      type: Boolean,
      default: true,
    },
    next: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      valid: false,
      loadingComponents: -1,
      unsavedChanges: false,
      resource: {
        paymentModel: null,
        pricing: null,
      },
      resourceLoading: true,
      extensions: [Bold, Italic, Underline, Strike, ListItem, BulletList, OrderedList],
      maxChars: 500,
    };
  },
  mounted() {
    this.loadingComponents++;
  },
  watch: {
    loading(value) {
      if (value === false) {
        console.log('Loading');
        if (this.id != null) {
          this.axios
            .get('/api/v1/resources/' + this.id)
            .then(res => {
              this.resource = res.data;
              this.$nextTick(() => {
                this.resourceLoading = false;
              });
            })
            .catch(error => {
              console.log({ error });
            });
        } else {
          this.resourceLoading = false;
        }
      }
    },
    resource: {
      handler: function(val, oldVal) {
        console.log('[Resource] Value changed');
        if (oldVal.id) {
          this.unsavedChanges = true;
        }
      },
      deep: true,
    },
  },
  computed: {
    charCount() {
      const div = document.createElement('div');
      div.innerHTML = this.resource.paymentModel || '';
      return div.textContent.length;
    },
    pricingCharCount() {
      const div = document.createElement('div');
      div.innerHTML = this.resource.pricing || '';
      return div.textContent.length;
    },
    loading() {
      return this.loadingComponents !== 0;
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel', true);
      this.unsavedChanges = false;
    },
    add() {
      EventBus.$emit('waiting', true);
      this.axios
        .post('/api/v1/resources/pricing-info', this.resource)
        .then(() => {
          console.log('Success');
          EventBus.$emit('snackbar', {
            text: this.$i18n.t('resource-updated'),
          });
          this.unsavedChanges = false;
        })
        .catch(error => {
          console.log({ error });
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
  },
};
</script>
